import { createSvgIcon } from '@mui/material/utils';

const AmaruIcon = createSvgIcon(
  <svg width="19" height="17" viewBox="0 0 19 17" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M11.4266 0.5H7.80114H7.79396L0.5 16.4722C0.5 16.4722 0.5 16.4861 0.507179 16.4861H4.46286H4.47004L5.94893 13.064C5.94893 13.064 5.94893 13.064 5.95611 13.064C8.51187 13.1542 8.41854 13.2931 9.8759 13.654C11.4984 14.0566 14.6428 16.4167 14.7505 16.5H18.4908C18.4908 16.5 18.5052 16.4931 18.498 16.4861L11.4338 0.5C11.4338 0.5 11.4338 0.5 11.4266 0.5ZM7.4709 9.8987L9.54566 4.7551C9.54566 4.7551 9.56002 4.74816 9.5672 4.7551L12.5896 11.1273C12.5896 11.1273 12.5896 11.1482 12.5752 11.1412C12.3311 11.044 10.2205 10.2458 7.47808 9.91258C7.47808 9.91258 7.46372 9.90564 7.4709 9.8987Z" fill="white" stroke="#414D5A" strokeMiterlimit="10"/>
</svg>
,
  'AmaruIcon',
);

export default AmaruIcon;
